/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_EventInputs */



/**
* | output |
* | --- |
* | "Select Event" |
*
* @param {Select_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_event = /** @type {((inputs?: Select_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner l’événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o evento")
	return /** @type {LocalizedString} */ ("Select Event")
});